import { createSelector } from '@ngrx/store';
import { getSharedState, SharedState } from '../shared.reducer';

const getTheme = createSelector(getSharedState, (state: SharedState) => state.theme.currentTheme);

export const ThemeSelectors = {
    getTheme
};
